import Vue from 'vue'
import Vuex from 'vuex'
import * as mutations from './mutation'

Vue.use(Vuex)

const state = {
  user: [],
  screenHeight: 0,
  screenWidth: 0,
  isLoading: false,
  edit: false,
  config: {}
}

const store = new Vuex.Store({
  mutations,
  state
})

export default store



// WEBPACK FOOTER //
// ./src/Vuex/store.js